
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.249 14.5h-2.5A1.25 1.25 0 0 1 2.5 13.25v-9.5A1.25 1.25 0 0 1 3.75 2.5h2.499m5.127 9.125L14.5 8.5m0 0-3.124-3.124M14.5 8.5H6"}})])
          )
        }
      }
    